export default __webpack_public_path__ + "static/media/right2.24966b63.svg";